import { getDocumentCatalogs } from '../../../services/MintAPI';

const DOCUMENT_CATALOGS_KEY = 'DOCUMENT_CATALOGS';

let DOCUMENT_CATALOGS = null;

export class DocumentCatalogsStore {

  static async init() {
    if (DOCUMENT_CATALOGS === null) {
      DOCUMENT_CATALOGS = await getDocumentCatalogs()
      sessionStorage.setItem(DOCUMENT_CATALOGS_KEY, JSON.stringify(DOCUMENT_CATALOGS))
    }
  }

  static async getDocumentCatalogs() {
    if (DOCUMENT_CATALOGS === null) {
      DOCUMENT_CATALOGS = sessionStorage.getItem(DOCUMENT_CATALOGS_KEY)
      if (DOCUMENT_CATALOGS) {
        DOCUMENT_CATALOGS = JSON.parse(DOCUMENT_CATALOGS);
      }
      else {
        await DocumentCatalogsStore.init();
      }
    }
    return DOCUMENT_CATALOGS;
  }
}
